import {Injectable} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs/internal/Observable';
import {AppConfimActionComponentMT} from '../../components/material/confirm-dialog/app-confim-action.component';
import { AppPinDialogComponentMT } from '../../components/material/pin-dialog/app-pin-dialog.component';
import { TranslateService } from '@ngx-translate/core';

export interface IconfirmDialogSettings {
    actionHeader?: string
    actionBody: string,
    isConfirmed?: boolean,
    data?: string,
    buttonLabel?: string,
    cancelButtonHide?: boolean
}

export type TNotification = Pick<IconfirmDialogSettings, "actionBody" | "actionHeader">

@Injectable({
    providedIn: 'root'
})
export class DialogsMTService {
    private dialogRefConfirm!: MatDialogRef<AppConfimActionComponentMT>;

    constructor(
        private dialog: MatDialog,
        private translateService:TranslateService
    ) {
    }

    confirmDialog(dialogSettings: IconfirmDialogSettings): Observable<{ isConfirmed: boolean }> {
        this.dialogRefConfirm = this.dialog.open(AppConfimActionComponentMT, {panelClass: 'confirm-dialog-padding-modalbox'});
        this.dialogRefConfirm.componentInstance.dialogSettings = dialogSettings
        return this.dialogRefConfirm.afterClosed()
    }
    openPinDialog(isSign: boolean, dialogHeader:string): Observable<{ pin: number }> {
      let pinDialogRef = this.dialog.open(AppPinDialogComponentMT);
      pinDialogRef.componentInstance.isSign = isSign;
      pinDialogRef.componentInstance.header = dialogHeader
      return  pinDialogRef.afterClosed()
    }
    setNotification(notifySettings: TNotification): Observable<{ isConfirmed: boolean }> {
        let dialogSettings: IconfirmDialogSettings = {
            ...notifySettings,
            cancelButtonHide: true
        }
        this.dialogRefConfirm = this.dialog.open(AppConfimActionComponentMT, {panelClass: 'confirm-dialog-padding-modalbox'});
        this.dialogRefConfirm.componentInstance.dialogSettings = dialogSettings
        return this.dialogRefConfirm.afterClosed()
    }
}
